import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DeveloperInsightSectionComponent } from '../developer-insight-section';

@Component({
  selector: 'app-developer-identity',
  templateUrl: './developer-identity.component.html',
  styleUrls: [
    './developer-identity.component.scss',
    '../developer-insight-section.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeveloperIdentityComponent extends DeveloperInsightSectionComponent {
  data: any;

  constructor() {
    super();
    this._developerStateService.developer$.subscribe(data => {
      this.data = data?.identityOverview;
    });
  }
}
